import styles from '../checkout/thankyoupage.module.scss'
import { RxCross2 } from "react-icons/rx";
import { useRouter } from 'next/router';

const ThankyouPage = () => {
    const router=useRouter();
    return (
        <div className={styles.etthankBg}>
            <div className={styles.thankcross} onClick={() => router.push('/newemployeetwin')}><RxCross2 /></div>
            <div className={styles.etthankBnr}>
                <div className={styles.etthankparacontainer}>

                    <p className={styles.etthankheading}>Thank you! </p>
                    <p className={styles.etthankpara}>
                        Your new Hire will be joining you in 7 working days with the set of soft skills.
                    </p>
                    <p className={styles.etthankparamain}>
                        HAP Delivery will be in touch with you to help on onboarding the Employee Twin with the other skills within 2 working days.</p>
                    <p className={styles.etthankpara}>
                        For any further queries, contact<br /><span className={styles.etthankparaspan}>HAP@Unilever.com</span></p>
                </div>
            </div>
        </div>
    )
}
export default ThankyouPage